import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette, colors, zIndex }: Theme) => createStyles({
  root: {
    '&:focus': {
      outline: 'none',
    },
  },
  iconMenu: {
    color: palette.icons.menu,
    '&:hover': {
      color: palette.navBar.hover,
    },
  },
  container: {
    cursor: 'pointer',
    alignItems: 'center',
    flexGrow: 1,
    '&:hover': {
      color: palette.navBar.hover,
    },
  },
  avatar: {
    margin: 10,
    width: 34,
    height: 34,
  },
  button: {
    '&:focus': {
      outline: 'none',
    },
  },
  menu: {
    boxSizing: 'border-box',
    width: 223,
    backgroundColor: palette.common.white,
    border: `1px solid ${colors.profileIcons}`,
    position: 'absolute',
    zIndex: zIndex.appBar,
    top: 65,
  },
  menuCompact: {
    top: 59,
    right: 1,
  },
  menuHidden: {
    display: 'none',
  },
  menuItem: {
    width: '100%',
    height: 44,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 18,
    fontSize: 14,
    backgroundColor: palette.common.white,
    color: '#4D595D',
    '&:hover': {
      textDecoration: 'none',
      color: palette.navBar.hover,
    },
  },
  menuButtonWrapperItem: {
    borderBottom: `1px ${colors.border} solid`,
    padding: 16,
  },
  menuButtonItem: {
    width: '100%',
    minWidth: 'unset',
    height: 32,
    padding: '0 12px 0 11px',
    color: palette.buttonAction.color,
    background: palette.buttonAction.background,
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
  },
  menuItemPrimary: {
    color: palette.primary.main,
  },
}), { name: 'MainBarUserMenu' });
